import { ArrowDownCircleIcon, ChatBubbleBottomCenterIcon, CheckCircleIcon, Cog6ToothIcon, PaperAirplaneIcon } from '@heroicons/react/20/solid';
import React, { useEffect, useState, useContext, F } from 'react';
import { ExclamationCircleIcon, QuestionMarkCircleIcon } from '@heroicons/react/20/solid';
import LoadingComponent from './loading';
import { AuthContext } from '../AuthContext';

export default function Bottlenecks({ tasks, onTriggerParentEffect }) {
  const [openModal, setOpenModal] = useState(null);
  const [help, setHelp] = useState("");
  const [loading, setLoading] = useState(false);
  const [taskList, setTaskList] = useState(tasks); // Use state to hold updated tasks
  const [ratings, setRatings] = useState({});

  console.log("Initial tasks prop:", taskList);

  const handleRating  = async (helpId, rating) => {

    try {

      const response = await fetch(`https://api.insightos.co.uk/api/ratehelp/${helpId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials : 'include',

        body: JSON.stringify({ Rating: rating }),
      });

      if (response.ok) {
        console.log("Help rating submitted");
        
    setRatings((prevRatings) => ({
      ...prevRatings,
      [helpId]: rating,
    }));
      }

    } catch (error) {
      console.error("Error submitting help rating:", error);
    }










  };

  const user = useContext(AuthContext);
  const token = localStorage.getItem('token');

    const fetchIssues = async () => {
      const taskIds = tasks.map((task) => task.TaskID);
    
      console.log("Task IDs:", taskIds);
    
      if (taskIds.length === 0) {
        console.error("No task IDs found.");
        return;
      }
    
      try {
        const response = await fetch("https://api.insightos.co.uk/api/getissues", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials : 'include',

          body: JSON.stringify({ TaskCalendarId: taskIds }),
        });
    
        if (response.ok) {
          const data = await response.json();
          console.log("Issues fetched:", data);

          console.log("Current tasks before updating:", tasks);
    
          // Filter and update task list with only tasks that have issues
          const updatedTasks = tasks.flatMap((task) => {
            // Get all issues related to this task
            const taskIssues = data.data.filter(
              (issue) => issue.TaskCalendarId === task.TaskID
            );
          
            // If no issues exist, return the task unchanged
            if (taskIssues.length === 0) {
              return [task]; // Keep it in an array since flatMap requires an array
            }
          
            // If there are multiple issues, create a separate task entry for each issue
            return taskIssues.map((issue) => ({
              ...task, // Copy existing task properties
              IssueDescription: issue.Description,
              IssueTried: issue.Tried,
              IssueTaskCalendarId : issue.TaskCalendarId,
              IssueAsk: issue.Ask,
              IssueId: issue.id, // Unique Issue ID
              SubstepName: issue.SubstepName,
              SubstepDescription: issue.SubstepDescription,
              SubstepId: issue.SubStepId,
              Help: issue.Help || [], // Keep Help array (default to empty if missing)
            }));
          });

          // now with updated tasks, if there is no IssueTaskCalendarId, remove it from the list
          const updatedTasksFiltered = updatedTasks.filter((task) => task.IssueTaskCalendarId);



          
          setTaskList(updatedTasksFiltered);


    
          console.log("Updated tasks with issues and help:", updatedTasks);
        } else {
          console.error("Failed to fetch issues");
        }
      } catch (error) {
        console.error("Error fetching issues:", error);
      }
    };
    
  useEffect(() => {
    
  
    fetchIssues();

    // update every 1 minute
    const interval = setInterval(() => {
      fetchIssues();
    }
    , 60000);
    return () => clearInterval(interval);


  }, [tasks, token]);  // Trigger effect when tasks or token change



  

  const handleSend = async (task) => {
    if (!help.trim()) {
      alert("Please enter a suggestion before sending.");
      return;
    }

    try {
      const response = await fetch("https://api.insightos.co.uk/api/savehelp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',
        body: JSON.stringify({
          IssueId: task.IssueId,
          Help: help,
          SubstepId: task.SubstepId
        }),
      });

      if (response.ok) {
        console.log("Suggested solution sent");
        setOpenModal(null);
        setHelp(""); // Clear the help text
        onTriggerParentEffect();
      } else {
        console.error("Failed to send help");
        alert("Failed to send suggestion. Please try again.");
      }
    } catch (error) {
      console.error("Error sending help:", error);
      alert("Error sending suggestion. Please try again.");
    }
  };

  const handleComplete = async (task) => {
    try {
      const response = await fetch(`https://api.insightos.co.uk/api/updateissue/${task.IssueId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',
      });

      if (response.ok) {
        console.log("Task marked as complete");
        setOpenModal(null); // Close any open modal
        onTriggerParentEffect();
      } else {
        console.error("Failed to mark task as complete");
        alert("Failed to mark task as complete. Please try again.");
      }
    } catch (error) {
      console.error("Error completing task:", error);
      alert("Error completing task. Please try again.");
    }
  };

  const handleAI = async (task) => {


    setLoading(true);
    try {
      const res = await fetch("https://api.insightos.co.uk/api/aitaskhelp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'include',
        body: JSON.stringify({ TaskID: task.IssueId, id: task.TaskID }),
      });

      const response = await res.json();

      if (response.success === true) {
        console.log("AI response generated");
        setLoading(false);
        onTriggerParentEffect();
      } else {
        console.error("Failed to generate AI response");
        setLoading(false);
        alert("Failed to generate AI response. Please try again.");
      }
    } catch (error) {
      console.error("Error generating AI response:", error);
      setLoading(false);
      alert("Error generating AI response. Please try again.");
    }
  };

  return (
    <div className="flex flex-col w-full rounded-md shadow-md p-2 sm:p-4 text-white">
      {loading && <LoadingComponent />}

      <h2 className="text-xl sm:text-2xl font-bold text-white rounded-lg p-2 bg-red-500 inline-block mb-4 text-center">
        Bottleneck Tasks
      </h2>
      {taskList.length === 0 ? (
        <p className="text-gray-500 text-center text-sm sm:text-base">No bottlenecks at the moment.</p>
      ) : (
        <ul role="list" className="grid grid-cols-1 gap-3 sm:gap-6">
          {taskList.map((task, index) => (
            <li key={index} className="col-span-1 rounded-lg bg-white shadow">
              <div className="flex flex-col sm:flex-row w-full items-start sm:items-center justify-between space-y-4 sm:space-y-0 sm:space-x-6 p-3 sm:p-6">
                <div className="flex-1 w-full">
                  <div className="flex flex-col sm:flex-row sm:items-center space-y-2 sm:space-y-0 sm:space-x-3">
                    <h3 className="text-sm font-medium text-gray-900">
                      {task.Task}
                    </h3>
                    <span className="inline-flex shrink-0 items-center rounded-full bg-green-50 px-1.5 py-0.5 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20 w-fit">
                      {task.Name}
                    </span>
                  </div>
                  <p className="mt-2 text-xs sm:text-sm text-gray-500">
                   Task Description: {task.Description}
                  </p>
                  <p className="mt-2 text-xs sm:text-sm text-gray-500">
                    Substep Name: {task.SubstepName}
                  </p>
                  <p className="mt-2 text-xs sm:text-sm text-gray-500">
                    Substep Description: {task.SubstepDescription}
                  </p>

                  <div className="flex flex-col space-y-3 sm:space-y-4 mt-2">
  {/* Issue Section */}
  <div className="flex items-start space-x-2">
    <ExclamationCircleIcon className="h-4 w-4 sm:h-5 sm:w-5 text-red-500 flex-shrink-0 mt-0.5" aria-hidden="true" />
    <div className="flex flex-col min-w-0">
      <p className="text-xs sm:text-sm text-red-500 break-words">Issue: {task.IssueDescription}</p>
      <p className="text-xs sm:text-sm text-red-500 break-words">Tried: {task.IssueTried}</p>
    </div>
  </div>

  {/* Help Suggestion Section */}
  <div>
      {task.Help &&
        task.Help.map((helpItem, index) => (
          <div
            key={index}
            className="flex flex-col mt-3 space-y-2 p-2 sm:p-3 bg-gray-100 rounded-lg shadow-md"
          >
            {/* Rating — only show if user is the task owner and hasn't rated yet */}
            {user.id === task.StaffId && !ratings[helpItem.id] && (
            <div className="flex flex-col sm:flex-row sm:items-center space-y-1 sm:space-y-0 sm:space-x-2 pb-2 pt-2">
              <span className="text-xs sm:text-sm font-medium text-gray-700">
                Rate Response:
              </span>
              <div className="flex items-center space-x-1">
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  className="h-4 w-4 sm:h-5 sm:w-5 text-base sm:text-lg text-gray-400 hover:text-yellow-500 transition-colors"
                  onClick={() => handleRating(helpItem.id, star)}
                  data-component="bottleneck-help-rating"
                  data-time-saved="3"
                  data-feature={`rate_help_${star}_post`}
                >
                  ★
                </button>
              ))}
              </div>
            </div>
            )}
           

            {/* Help Description */}
            <div className="flex items-start space-x-2">
              <QuestionMarkCircleIcon
                className="h-4 w-4 sm:h-5 sm:w-5 text-emerald-500 flex-shrink-0 mt-0.5"
                aria-hidden="true"
              />
              <p className="text-xs sm:text-sm rounded-md p-2 bg-emerald-500 text-white break-words flex-1">
                {helpItem.Description}
              </p>
            </div>

            {/* Footer: Staff Name & CreatedAt */}
            <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center space-y-1 sm:space-y-0 text-xs text-gray-600">
              <span className="font-semibold text-sm sm:text-lg">{helpItem.StaffName}</span>
              <span className="text-xs">{new Date(helpItem.CreatedAt).toLocaleString()}</span>
            </div>
          </div>
        ))}
    </div>
</div>


                  {openModal === task && user.id !== task.StaffId && (
                    <div className="relative mt-4 w-full">
                      <div className="flex justify-between items-center mb-2">
                        <span className="text-sm font-medium text-gray-700">Suggest a solution:</span>
                        <button
                          onClick={() => setOpenModal(null)}
                          className="text-gray-400 hover:text-gray-600 text-xl leading-none"
                        >
                          ×
                        </button>
                      </div>
                      <textarea
                        onChange={(e) => setHelp(e.target.value)}
                        id="help"
                        name="help"
                        type="text"
                        value={help}
                        className="w-full h-20 sm:h-24 p-2 border border-gray-300 rounded-md text-black text-sm resize-none"
                        placeholder="Suggest a solution..."
                      />
                      <div className="absolute bottom-2 right-2 flex space-x-1">
                        <button 
                          onClick={() => handleAI(task)} 
                          type="button" 
                          data-component="bottleneck-help-actions"
                          data-feature="generate_ai_help_post"
                          data-time-saved="30"
                          className="rounded-full inline-flex items-center p-1.5 sm:p-2 border border-transparent text-sm font-medium shadow-sm bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                          title="Generate AI suggestion"
                        >
                          <Cog6ToothIcon className="h-3 w-3 sm:h-4 sm:w-4 text-white" aria-hidden="true" />
                        </button>
                        <button 
                          onClick={() => handleSend(task)} 
                          type="button" 
                          data-component="bottleneck-help-actions"
                          data-feature="submit_help_post"
                          data-time-saved="5"

                          className="rounded-full inline-flex items-center p-1.5 sm:p-2 border border-transparent text-sm font-medium shadow-sm bg-emerald-600 hover:bg-emerald-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-emerald-500"
                          title="Send suggestion"
                        >
                          <PaperAirplaneIcon className="h-3 w-3 sm:h-4 sm:w-4 text-white" aria-hidden="true" />
                        </button>
                      </div>
                    </div>
                  )}
                </div>
                <div className="h-8 w-8 sm:h-10 sm:w-10 rounded-full flex items-center justify-center bg-red-500 flex-shrink-0 sm:mt-0 self-start sm:self-center">
                  <span className="text-white font-bold text-sm">
                    {task.IssueAsk === "manager" ? "M" : "T"}
                  </span>
                </div>
              </div>
              <div className="flex border-t border-gray-200 mt-2">
                <button
                  type="button"
                  onClick={() => setOpenModal(task)}
                  disabled={user.id === task.StaffId}
                  data-component="bottleneck-task-actions"
                  data-feature="open_suggest_modal"
                  className={`flex flex-1 items-center justify-center gap-x-1 sm:gap-x-2 rounded-bl-lg py-3 sm:py-4 text-xs sm:text-sm font-semibold border-r border-gray-200 ${
                    user.id === task.StaffId
                      ? 'text-gray-400 cursor-not-allowed bg-gray-50'
                      : 'text-gray-900 hover:bg-emerald-50'
                  }`}
                >
                  <ChatBubbleBottomCenterIcon aria-hidden="true" className="h-4 w-4 sm:h-5 sm:w-5 text-emerald-500 flex-shrink-0" />
                  <span className="hidden sm:inline">Suggest Solution</span>
                  <span className="sm:hidden">Suggest</span>
                </button>
                <button
                  onClick={() => handleComplete(task)}
                  type="button"
                  data-component="bottleneck-task-actions"
                  data-feature="mark_issue_complete_post"
                  className="flex flex-1 items-center justify-center gap-x-1 sm:gap-x-2 rounded-br-lg py-3 sm:py-4 text-xs sm:text-sm font-semibold text-gray-900 hover:bg-gray-100"
                >
                  <CheckCircleIcon aria-hidden="true" className="h-4 w-4 sm:h-5 sm:w-5 text-gray-400 flex-shrink-0" />
                  <span className="hidden sm:inline">Mark as Complete</span>
                  <span className="sm:hidden">Complete</span>
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
